import { parserMoney, postRequest } from "../../../../Utils/Functions";
import { useEffect, useState } from "react";
import { gql } from "@apollo/client/core";
import { useQuery } from "@apollo/client";
import fetcher from "src/utils/fetcher";

const QUERY_PRICE = gql`
	query property($id: ID) {
		property(id: $id) {
			price {
				currency {
					name
				}
				amount
			}
		}
	}
`;

const ITAU_SERVICE = "https://prod.infocasas.com.uy/microservices/simulador/?/itau/simulation";
const ITAU_GET_VALUES =
	"https://prod.infocasas.com.uy/microservices/simulador/?/itau/getValuesProperty/";

const TYPES = [
	{
		value: "UI",
		text: "Unidades Indexadas",
	},
	{
		value: "USD",
		text: "Dolares",
	},
];

export const useItauFinancingV2 = ({ id, source, showFinancingCard }) => {
	const { data: propertyData } = useQuery(QUERY_PRICE, { variables: { id } });
	const [loan, setLoan] = useState(propertyData?.property?.price?.amount * 0.8);
	const [propertyPrice, setPropertyPrice] = useState(0);
	const [propertyCurrency, setPropertyCurrency] = useState(undefined);
	const [years, setYears] = useState(20);
	const [type, setType] = useState(TYPES[0].value);
	const [payment, setPayment] = useState(0);
	const [matchedYears, setMatchedYears] = useState([]);
	const [, setIsDefaultSimulation] = useState(true);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	let timer = null;

	const thirdYearsOptions = Array.from(Array(10), (e, i) => i + 1);
	const fourthYearsOptions = Array.from(Array(20), (e, i) => i + 1);

	const YEARS = matchedYears.map(year => ({
		value: year,
		text: `${year} año${year > 1 ? "s" : ""}`,
	}));

	useEffect(() => {
		if (type === "UI") {
			setMatchedYears(fourthYearsOptions);
		} else if (type === "USD") {
			setMatchedYears(thirdYearsOptions);
			if (years > 10) {
				setYears(10);
			}
		}
	}, [type]);

	useEffect(() => {
		if (propertyData && propertyData.property) {
			setPropertyPrice(propertyData?.property?.price?.amount);
			setPropertyCurrency(propertyData?.property?.price?.currency?.name);
		}
	}, [propertyData]);

	useEffect(() => {
		const getValues = async () => {
			setLoading(true);
			setError(null);
			try {
				const body = {
					propertyValue: propertyPrice,
					loanAmount: loan,
					currencyCode: type,
					termYears: years,
					purpose: 1,
					personType: "F",
				};
				const data = await fetcher<any>(
					`${process.env.graphQL_uri?.replace("/graphql", "")}/api/1.0/itau/calculate`,
					{
						method: "POST",
						body: JSON.stringify(body),
					}
				);
				if (type === "UI") {
					setPayment(parserMoney(data?.detalleCotizacion?.cuota_referencia_UYU));
				} else if (type === "USD") {
					setPayment(parserMoney(data?.detalleCotizacion?.cuota_referencia_USD));
				}
				// setPropertyPrice(parserMoney(propertyPrice));
				// setLoan(parserMoney(data.detalleCotizacion.monto_solicitado));
				// setYears(data.detalleCotizacion.plazo / 12);
				// setType(data.detalleCotizacion.destino);
				// setAsset(data.detalleCotizacion.financiacion);
				// setIsDefaultSimulation(true);
			} catch (error) {
				setError(error);
				return;
			} finally {
				setLoading(false);
			}
		};

		if (
			propertyPrice > 0 &&
			loan >= 40_000 &&
			Math.round((loan * 100) / propertyPrice) <= 80 &&
			((type === "UI" && years <= 20) || (type === "USD" && years <= 10))
		) {
			getValues();
		}
	}, [propertyPrice, loan, type, years]);

	return {
		loan: {
			amount: loan,
			change: setLoan,
		},
		property: {
			amount: propertyPrice,
		},
		years: {
			totalYears: YEARS,
			value: years,
			change: setYears,
		},
		type: {
			options: TYPES,
			value: type,
			change: setType,
		},
		setIsDefaultSimulation,
		payment,
		propertyCurrency,
		show: true,
		loading,
		error,
	};
};

